function getRequiredSteps(container) {
  return Array.from(container.querySelectorAll("[data-product-form-step]")).filter(
    (step) => step.dataset.stepType !== "product-group",
  );
}

function hasIncompleteRequiredStep(container) {
  return getRequiredSteps(container).some((step) =>
    step.classList.contains("product-form__accordion--unselected"),
  );
}

function enforceSuitAddToCartGuard(root = document) {
  root.querySelectorAll("[data-product-form-selectors]").forEach((container) => {
    const productForm = container.closest("product-form");
    const addToCartButton = productForm?.querySelector("[data-product-form-atc]");

    if (!addToCartButton) {
      return;
    }

    if (hasIncompleteRequiredStep(container)) {
      addToCartButton.disabled = true;
    }

    const nextUp = productForm.querySelector("[data-product-next-up]");

    if (nextUp) {
      nextUp.hidden = addToCartButton.disabled;
    }
  });
}

enforceSuitAddToCartGuard(document);

document.addEventListener("change", (event) => {
  if (event.target.closest("[data-product-form-selectors]")) {
    enforceSuitAddToCartGuard(document);
  }
});

document.addEventListener("product:ajax-rendered", (event) => {
  enforceSuitAddToCartGuard(event.detail?.section || document);
});
